(() => {
  const root = window.ydRoot || '/';

  const showToast = (message, isError = false) => {
    const toast = document.getElementById('YdToast');
    const text = document.getElementById('YdToastText');
    if (!toast || !text) return;
    text.textContent = message;
    toast.classList.toggle('is-error', isError);
    toast.classList.add('is-visible');
    window.clearTimeout(window.ydToastTimer);
    window.ydToastTimer = window.setTimeout(() => toast.classList.remove('is-visible'), 4300);
  };

  const refreshCartCount = async () => {
    try {
      const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      const cart = await response.json();
      document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
    } catch (_) {}
  };

  const addVariant = async (id, quantity = 1) => {
    const response = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(quantity) || 1 }] })
    });
    const payload = await response.json();
    if (!response.ok) throw new Error(payload.description || 'No fue posible agregar este producto.');
    await refreshCartCount();
    showToast('Tu producto digital se agregó correctamente.');
    return payload;
  };

  const initMenu = (scope = document) => {
    const toggle = document.querySelector('[data-site-menu-toggle]');
    const panel = document.querySelector('[data-site-mobile-menu]');
    if (!toggle || !panel || toggle.dataset.bound) return;
    toggle.dataset.bound = 'true';
    const openIcon = toggle.querySelector('[data-menu-open]');
    const closeIcon = toggle.querySelector('[data-menu-close]');
    const setOpen = (open) => {
      toggle.setAttribute('aria-expanded', String(open));
      panel.hidden = !open;
      if (openIcon) openIcon.hidden = open;
      if (closeIcon) closeIcon.hidden = !open;
      document.body.classList.toggle('site-menu-open', open);
    };
    toggle.addEventListener('click', () => setOpen(toggle.getAttribute('aria-expanded') !== 'true'));
    panel.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setOpen(false)));
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape') setOpen(false); });
    window.addEventListener('resize', () => { if (window.innerWidth >= 900) setOpen(false); });
  };

  const initTabs = (scope = document) => {
    scope.querySelectorAll('[data-site-tabs]').forEach((tabsRoot) => {
      if (tabsRoot.dataset.bound) return;
      tabsRoot.dataset.bound = 'true';
      const tabs = Array.from(tabsRoot.querySelectorAll('[data-site-tab]'));
      const panels = Array.from(tabsRoot.querySelectorAll('[data-site-panel]'));
      const activate = (name) => {
        tabs.forEach((tab) => {
          const active = tab.dataset.siteTab === name;
          tab.dataset.state = active ? 'active' : 'inactive';
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });
        panels.forEach((panel) => { panel.hidden = panel.dataset.sitePanel !== name; });
      };
      tabs.forEach((tab) => tab.addEventListener('click', () => activate(tab.dataset.siteTab)));
      activate((tabs.find((tab) => tab.dataset.state === 'active') || tabs[0])?.dataset.siteTab);
    });
  };

  const initCatalog = (scope = document) => {
    scope.querySelectorAll('[data-catalog-root]').forEach((catalog) => {
      if (catalog.dataset.bound) return;
      catalog.dataset.bound = 'true';
      const input = catalog.querySelector('[data-catalog-search]');
      const buttons = Array.from(catalog.querySelectorAll('[data-catalog-filter]'));
      const cards = Array.from(catalog.querySelectorAll('[data-catalog-card]'));
      const count = catalog.querySelector('[data-catalog-count]');
      const empty = catalog.querySelector('[data-catalog-empty]');
      const reset = catalog.querySelector('[data-catalog-reset]');
      let filter = 'todos';

      const normalize = (value) => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
      const apply = () => {
        const query = normalize(input?.value);
        let visible = 0;
        cards.forEach((card) => {
          const categoryMatches = filter === 'todos' || card.dataset.category === filter;
          const searchMatches = !query || normalize(card.dataset.search).includes(query);
          const show = categoryMatches && searchMatches;
          card.hidden = !show;
          if (show) visible += 1;
        });
        if (count) count.textContent = `${visible} ${visible === 1 ? 'producto' : 'productos'}`;
        if (empty) {
          if (!cards.length) empty.hidden = false;
          else empty.hidden = visible !== 0;
        }
      };

      buttons.forEach((button) => button.addEventListener('click', () => {
        filter = button.dataset.catalogFilter;
        buttons.forEach((item) => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });
        apply();
      }));
      input?.addEventListener('input', apply);
      reset?.addEventListener('click', () => {
        filter = 'todos';
        if (input) input.value = '';
        buttons.forEach((item) => {
          const active = item.dataset.catalogFilter === 'todos';
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });
        apply();
      });
      apply();
    });
  };

  const initCartButtons = (scope = document) => {
    scope.querySelectorAll('[data-add-to-cart]').forEach((button) => {
      if (button.dataset.bound) return;
      button.dataset.bound = 'true';
      button.addEventListener('click', async () => {
        const original = button.innerHTML;
        button.disabled = true;
        button.textContent = 'Agregando…';
        try { await addVariant(button.dataset.variantId, 1); }
        catch (error) { showToast(error.message, true); }
        finally { button.disabled = false; button.innerHTML = original; }
      });
    });

    scope.querySelectorAll('[data-product-form]').forEach((form) => {
      if (form.dataset.bound) return;
      form.dataset.bound = 'true';
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const button = form.querySelector('[type="submit"]');
        const formData = new FormData(form);
        if (!formData.get('id')) return;
        const original = button ? button.innerHTML : '';
        if (button) { button.disabled = true; button.textContent = 'Agregando…'; }
        try { await addVariant(formData.get('id'), formData.get('quantity')); }
        catch (error) { showToast(error.message, true); }
        finally { if (button) { button.disabled = false; button.innerHTML = original; } }
      });
    });
  };

  const initFaq = (scope = document) => {
    scope.querySelectorAll('.faq__accordion details').forEach((item) => {
      if (item.dataset.bound) return;
      item.dataset.bound = 'true';
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        item.closest('.faq__accordion')?.querySelectorAll('details[open]').forEach((other) => { if (other !== item) other.open = false; });
      });
    });
  };

  const init = (scope = document) => {
    initMenu(scope);
    initTabs(scope);
    initCatalog(scope);
    initCartButtons(scope);
    initFaq(scope);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
